import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import LoadCard from './LoadCard';

function SortableLoadCard({ load, onClick }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: load.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    marginBottom: '0.75rem'
  };

  const handleClick = (e) => {
    // Only trigger onClick if not dragging and it's a simple click (not drag)
    if (!isDragging && onClick) {
      onClick(load);
    }
  };

  return (
    <div 
      ref={setNodeRef} 
      style={style} 
      {...attributes} 
      {...listeners}
      onClick={handleClick}
    >
      <LoadCard load={load} isDragging={isDragging} />
    </div>
  );
}

export default SortableLoadCard;
